import React, { useEffect, useState, useCallback } from "react";
import * as M from "moment";
import { debounce } from "lodash";
import { observer } from "mobx-react-lite";
import Paths from "../../constants/PathsBreadcrumbs";
import { useHandleForm } from "../../hooks/useHandleForm";
import { useBreadcrumbs } from "../../hooks/useBreadcrumbs";
import {
  ExpandedTable,
  StoredPagination,
  SearchFormField,
  Layout,
  ITooltip,
} from "../../ui-kit";
import SystemDictionariesStore from "../../store/systemDictionaries";
import Constants from "../../constants/Common";
import DictItems from "./form/dictItems";

import styles from "./styles.module.scss";
import { UploadIco } from "../../assets/customIcons";
import dictionaryStore from "../../store/dictionary";
import ImportModal from "./components/ImportModal";
import { runInAction } from "mobx";
import { authStore } from "../../store/authStore";

const NsiSystem: React.FC = observer(({}) => {
  const { data, dataIsLoading, dataRowKeys, paginator, search, sorter } =
    SystemDictionariesStore;

  const [searchText, setSearchText] = useState("");

  const { isFocused, handleBlur, handleFocus } = useHandleForm(
    null,
    { search: "" },
    { search: false },
  );

  const debouncedQuery = useCallback(
    debounce((query) => (search.text = query), 500),
    [],
  );

  const handleChangeSearch = (event) => {
    setSearchText(event.target.value);
    if (event.target.value) {
      debouncedQuery(event.target.value);
    }
  };

  const handleClearSearch = () => {
    search.text = "";
    setSearchText("");
  };

  const importDictionary = (e, record) => {
    e.stopPropagation();
    runInAction(() => {
      dictionaryStore.currentDictItem = record;
      dictionaryStore.isImportModalVisible.setTrue();
    });
  };

  useEffect(() => {
    SystemDictionariesStore.getData();
  }, [paginator.page, paginator.perPage, search.text, sorter.changingKey]);

  useBreadcrumbs(Paths.nsiSystem);

  const columns = [
    {
      title: "№",
      dataIndex: "id",
      key: "id",
      render: (res) => (res ? res : "-"),
      sortable: true,
      width: "10%",
    },
    {
      title: "Наименование",
      dataIndex: "title",
      key: "title",
      render: (res) => (res ? res : "-"),
      sortable: true,
      width: "35%",
      className: "align-left",
    },
    {
      title: "Код",
      dataIndex: "name",
      key: "name",
      render: (res) => (res ? res : "-"),
      sortable: true,
      width: "15%",
    },
    {
      title: "Количество элементов",
      dataIndex: "itemsQty",
      key: "itemsQty",
      render: (_, record) => record.items.length,
      width: "10%",
    },
    {
      title: "Дата последнего изменения справочника",
      dataIndex: "dtModified",
      key: "dtModified",
      render: (_, record) => {
        const date = record.modified || record.created;
        return date ? M(date).format(Constants.dateFormat) : "";
      },
      width: "15%",
    },
    {
      title: "Дата последнего изменения элементов",
      dataIndex: "dtModifiedEl",
      key: "dtModifiedEl",
      render: (_, record) => {
        const date = record.items.reduce((prev, element) => {
          const date =
            element.modified && element.modified > element.created
              ? element.modified
              : element.created;
          return date > prev ? date : prev;
        }, "");
        return date ? M(date).format(Constants.dateFormat) : "";
      },
      width: "15%",
    },
    {
      title: " ",
      key: "import",
      render: (_, record) => {
        if (
          record.name === "Address" &&
          (authStore.userProfile.userRole === "ADMIN" ||
            authStore.userProfile.userRole === "CES")
        ) {
          return (
            <ITooltip title={Constants.titleIcons.update} placement="right">
              <UploadIco onClick={(e) => importDictionary(e, record)} />
            </ITooltip>
          );
        }
        return null;
      },
      className: "delete-cell",
    },
  ];

  return (
    <>
      <Layout type="white">
        <div className={styles.search}>
          <SearchFormField
            name="search"
            label="Поиск по названию и пунктам справочника"
            type="text"
            value={searchText}
            isFocused={isFocused.search}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onClear={handleClearSearch}
            onChange={handleChangeSearch}
            onFindClick={SystemDictionariesStore.getData}
          />
        </div>
        <ExpandedTable
          columns={columns}
          data={data}
          sort={sorter}
          rowKey={(record) => record.id}
          rowKeys={dataRowKeys.keys}
          setRowKeys={dataRowKeys.setKeys}
          rowsLength={paginator.perPage}
          loading={dataIsLoading.value}
          expandElementClassName="dataList"
        >
          <DictItems />
        </ExpandedTable>
        <StoredPagination {...paginator} />
      </Layout>
      <ImportModal />
    </>
  );
});

export default NsiSystem;
